import { render } from "./HeroiconsSolidArrowNarrowDown.vue?vue&type=template&id=1782abc0"
const script = {}

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowNarrowDown.vue"]])

export default __exports__